export default __webpack_public_path__ + "static/springandsummer (7)-b6651ed17c71ed24b9cb01037be86312.jpeg";